
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18","width":"20"}},[_c('path',{attrs:{"fill":"#EA4335","d":"M9 3.56c1.33 0 2.52.46 3.45 1.35l2.57-2.57C13.46.89 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.99 2.32C4.66 5.14 6.65 3.56 9 3.56z"}}),_c('path',{attrs:{"fill":"#4285F4","d":"M17.62 9.21c0-.59-.06-1.16-.14-1.71H9v3.38h4.85a4.184 4.184 0 01-1.79 2.69l2.9 2.25c1.69-1.56 2.66-3.88 2.66-6.61z"}}),_c('path',{attrs:{"fill":"#FBBC05","d":"M3.95 10.72c-.18-.54-.29-1.12-.29-1.72s.1-1.18.29-1.72L.96 4.96C.34 6.17 0 7.55 0 9s.34 2.83.96 4.04l2.99-2.32z"}}),_c('path',{attrs:{"fill":"#34A853","d":"M9 18c2.43 0 4.47-.8 5.96-2.18l-2.9-2.25c-.81.54-1.84.86-3.06.86-2.35 0-4.34-1.58-5.05-3.72L.96 13.03A8.984 8.984 0 009 18z"}}),_c('path',{attrs:{"fill":"none","d":"M0 0h18v18H0V0z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      